import { ACHIEVEMENT_TIERS } from '@didaskill/domain/user-achievements/constants';
import { TILE_VARIANTS } from '@didaskill/ui/design-system';

export const ACHIEVEMENT_TILE_VARIANTS_MAP: Record<ACHIEVEMENT_TIERS, TILE_VARIANTS> = {
  [ACHIEVEMENT_TIERS.NEUTRAL]: TILE_VARIANTS.PRIMARY,
  [ACHIEVEMENT_TIERS.BRONZE]: TILE_VARIANTS.SECONDARY,
  [ACHIEVEMENT_TIERS.SILVER]: TILE_VARIANTS.TERTIARY,
  [ACHIEVEMENT_TIERS.GOLD]: TILE_VARIANTS.WARNING,
  [ACHIEVEMENT_TIERS.QUEST]: TILE_VARIANTS.CHROME,
};
